/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ArticleInput = {
    headline?: string | null;
    description?: string | null;
    body?: string | null;
    slug?: string | null;
    thumbnailUrl?: string | null;
    thumbnailAttribution?: string | null;
    thumbnailChecksum?: string | null;
    videoId?: unknown | null;
    authorIds?: Array<unknown> | null;
    templateVersionId?: unknown | null;
    tags?: Array<TagInput> | null;
    heroImageUrl?: string | null;
    videoFileId?: unknown | null;
    publishedAt?: string | null;
};
export type TagInput = {
    source: unknown;
    value: Array<string>;
};
export type ArticleDetailMutationVariables = {
    id: string;
    input: ArticleInput;
};
export type ArticleDetailMutationResponse = {
    readonly articleUpdate: {
        readonly draft: {
            readonly " $fragmentRefs": FragmentRefs<"ArticleDetail_draft">;
        };
    } | null;
};
export type ArticleDetailMutation = {
    readonly response: ArticleDetailMutationResponse;
    readonly variables: ArticleDetailMutationVariables;
};



/*
mutation ArticleDetailMutation(
  $id: ID!
  $input: ArticleInput!
) {
  articleUpdate(draftId: $id, input: $input) {
    draft {
      ...ArticleDetail_draft
      id
    }
  }
}

fragment ArticleDetail_draft on Draft {
  id
  scheduledFor
  ...Controls_draft
  canUpdate
  draftable {
    __typename
    selectableTemplates {
      versions {
        id
        version
      }
      id
    }
    ... on Article {
      id
      body
      description
      headline
      slug
      thumbnailAttribution
      ...Thumbnail_article
      ...Preview_article
      ...HeroPicker_article
      ...BylineSelect_draftable
      ...PublicationDate_draftable
      ...TagFieldRenderer_taggable
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  errors {
    field
    messages
  }
  warnings {
    field
    messages
  }
}

fragment BylineSelect_draftable on Article {
  authors {
    id
    byline
  }
}

fragment Controls_draft on Draft {
  id
  canDelete
  canEdit
  canPublish
  canUpdate
  updatedAt
  administrators {
    privilege
    user {
      id
      first_name
      last_name
      avatar_url
    }
  }
  draftable {
    ... on Article {
      id
      deletedAt
    }
    lastPublishedAt
    __typename
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment HeroPicker_article on Article {
  organization {
    id
  }
  heroImageUrl
  videoFile {
    id
    videoUrls {
      url
      mime
    }
  }
}

fragment Preview_article on Article {
  headline
  heroImageUrl
  video {
    video_urls {
      url
      mime
    }
    id
  }
  videoFile {
    videoUrls {
      url
      mime
    }
    id
  }
  html
}

fragment PublicationDate_draftable on Article {
  publishedAt
}

fragment TagFieldRenderer_taggable on Article {
  tags {
    name
  }
  ...TagField_taggable
}

fragment TagField_taggable on Article {
  tags {
    id
    name
    fixedOptions
    value
    type
  }
}

fragment Thumbnail_article on Article {
  thumbnailUrl
  thumbnails {
    small
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "draftId",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mime",
    "storageKey": null
  }
],
v4 = [
  (v2/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "field",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "messages",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArticleDetailMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArticleUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "articleUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Draft",
            "kind": "LinkedField",
            "name": "draft",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArticleDetail_draft"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArticleDetailMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArticleUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "articleUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Draft",
            "kind": "LinkedField",
            "name": "draft",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduledFor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canDelete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canEdit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canPublish",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canUpdate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftAdministrator",
                "kind": "LinkedField",
                "name": "administrators",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "privilege",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "first_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "last_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "avatar_url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "draftable",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastPublishedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Template",
                    "kind": "LinkedField",
                    "name": "selectableTemplates",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Draft",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "version",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailAttribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Thumbnail",
                        "kind": "LinkedField",
                        "name": "thumbnails",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "small",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heroImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Video",
                        "kind": "LinkedField",
                        "name": "video",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Url",
                            "kind": "LinkedField",
                            "name": "video_urls",
                            "plural": true,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoFile",
                        "kind": "LinkedField",
                        "name": "videoFile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Url",
                            "kind": "LinkedField",
                            "name": "videoUrls",
                            "plural": true,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "html",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "byline",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publishedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fixedOptions",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v4/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Error",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Error",
                "kind": "LinkedField",
                "name": "warnings",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3b3781e13a25580260535a11f98628c",
    "id": null,
    "metadata": {},
    "name": "ArticleDetailMutation",
    "operationKind": "mutation",
    "text": "mutation ArticleDetailMutation(\n  $id: ID!\n  $input: ArticleInput!\n) {\n  articleUpdate(draftId: $id, input: $input) {\n    draft {\n      ...ArticleDetail_draft\n      id\n    }\n  }\n}\n\nfragment ArticleDetail_draft on Draft {\n  id\n  scheduledFor\n  ...Controls_draft\n  canUpdate\n  draftable {\n    __typename\n    selectableTemplates {\n      versions {\n        id\n        version\n      }\n      id\n    }\n    ... on Article {\n      id\n      body\n      description\n      headline\n      slug\n      thumbnailAttribution\n      ...Thumbnail_article\n      ...Preview_article\n      ...HeroPicker_article\n      ...BylineSelect_draftable\n      ...PublicationDate_draftable\n      ...TagFieldRenderer_taggable\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  errors {\n    field\n    messages\n  }\n  warnings {\n    field\n    messages\n  }\n}\n\nfragment BylineSelect_draftable on Article {\n  authors {\n    id\n    byline\n  }\n}\n\nfragment Controls_draft on Draft {\n  id\n  canDelete\n  canEdit\n  canPublish\n  canUpdate\n  updatedAt\n  administrators {\n    privilege\n    user {\n      id\n      first_name\n      last_name\n      avatar_url\n    }\n  }\n  draftable {\n    ... on Article {\n      id\n      deletedAt\n    }\n    lastPublishedAt\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment HeroPicker_article on Article {\n  organization {\n    id\n  }\n  heroImageUrl\n  videoFile {\n    id\n    videoUrls {\n      url\n      mime\n    }\n  }\n}\n\nfragment Preview_article on Article {\n  headline\n  heroImageUrl\n  video {\n    video_urls {\n      url\n      mime\n    }\n    id\n  }\n  videoFile {\n    videoUrls {\n      url\n      mime\n    }\n    id\n  }\n  html\n}\n\nfragment PublicationDate_draftable on Article {\n  publishedAt\n}\n\nfragment TagFieldRenderer_taggable on Article {\n  tags {\n    name\n  }\n  ...TagField_taggable\n}\n\nfragment TagField_taggable on Article {\n  tags {\n    id\n    name\n    fixedOptions\n    value\n    type\n  }\n}\n\nfragment Thumbnail_article on Article {\n  thumbnailUrl\n  thumbnails {\n    small\n  }\n}\n"
  }
};
})();
(node as any).hash = '299e6454ba52ab58cf10b33adf4c5402';
export default node;
